import React, { useState, useEffect } from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import SortIcon from "@material-ui/icons/Sort";
import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";
import { CommonCss } from "../../services/CommonCss";
import Radio from "@material-ui/core/Radio";
import Moment from "react-moment";

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

//const customerContractData = require("../../../data/customerContractDetails.json");
//const contractData = [];
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },

  
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  headBox: {
    background: "#1A1A31 0% 0% no-repeat padding-box",
    borderRadius: "10px 10px 0px 0px",
  },
  mainBox: {
    boxShadow: "3px 3px 6px #00000029",
    borderRadius: " 0px 0px 10px 10px",
  },
  text1: {
    fontSize: "17px",
    letterSpacing: "0.54px",
    fontWeight: 400,
    color: "#1A1A31",
  },
  text2: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#5A5B5E",
  },
  text3: {
    fontSize: "21px",
    fontWeight: 600,
    color: "#fff",
    letterSpacing: "0.63px",
  },
  rowHeaderBox: {
    "& div": {
      borderRight: "1px solid #707070",
      paddingRight: "8px",
    },
  },
  rowBox: {
    borderBottom: "1px solid #00000029",
    boxShadow: "0 1px 0px 0px #00000029",
  },
  hoverBox: {
    boxShadow: "3px 3px 6px #00000029",
    borderRadius: "10px",
  },
  sortBy: {
    right: "66px",
  },
  downloadBy: {
    right: "0px",
  },
  radioButton: {
    padding: "0px",
    paddingRight: "4px",
    "& svg": {
      fontSize: "1rem",
    },
  },
  radio: {
    "&$checked": {
      color: "#4B8DF8",
    },
  },
}));
function CustomerContractDetails(props) {
  const classes = useStyles();
  const commonClasses = CommonCss();
  const [sortBy, setSortBy] = useState(false);
  const [downloadBy, setDownloadBy] = useState(false);
  const{ rows, dataOfEquipement }= props;
  return (
    <div>
      <Box bgcolor="#fff" className={clsx(classes.mainBox)}>
        <Box
          background="#1A1A31"
          position="relative"
          px={4}
          py={1}
          color="#fff"
          className={clsx(classes.headBox)}
        >
          <Box
            display="flex"
            className={clsx(classes.text3, commonClasses.justifyContentBetween)}
          >
            <Box>Equipment</Box>
            <Box>
              <Box className="hidediv" component="span" pr={2}>
                <SortIcon
                  className={commonClasses.cursorPointer}
                  onClick={() => {
                    setDownloadBy(false);
                    setSortBy(!sortBy);
                  }}
                />
                <Box
                  position="absolute"
                  className={clsx(classes.hoverBox, classes.sortBy)}
                  zIndex={3}
                  bgcolor="#fff"
                  display={sortBy ? "block" : "none"}
                  top={52}
                  width={0.08}
                  px={2}
                  pb={4}
                >
                  <Box component="h6" my={1} color="#FF4717" fontSize="15px">
                    Sort By:
                  </Box>
                  <Box
                    component="p"
                    m={0}
                    pb={1}
                    color="#5A5B5E"
                    fontSize="12px"
                    display="flex"
                    alignItems="center"
                  >
                    <Radio
                      value="Sequence"
                      name="radio-button-sort"
                      className={clsx(classes.radioButton)}
                      py={1}
                    />
                    <Box>Sequence</Box>
                  </Box>
                  <Box
                    component="p"
                    m={0}
                    pb={1}
                    color="#5A5B5E"
                    fontSize="12px"
                    display="flex"
                    alignItems="center"
                  >
                    <Radio
                      value="Group"
                      name="radio-button-sort"
                      className={clsx(classes.radioButton)}
                      py={1}
                    />
                    <Box>Group</Box>
                  </Box>
                </Box>
              </Box>
              <Box  className="hidediv" component="span">
                <GetAppIcon
                  className={commonClasses.cursorPointer}
                  onClick={() => {
                    setSortBy(false);
                    setDownloadBy(!downloadBy);
                  }}
                />
                <Box
                  position="absolute"
                  className={clsx(classes.hoverBox, classes.downloadBy)}
                  zIndex={3}
                  bgcolor="#fff"
                  display={downloadBy ? "block" : "none"}
                  top={52}
                  width={0.08}
                  px={2}
                  pb={4}
                >
                  <Box component="h6" my={1} color="#FF4717" fontSize="15px">
                    Download:
                  </Box>
                  <Box
                    component="p"
                    m={0}
                    pb={1}
                    color="#5A5B5E"
                    fontSize="12px"
                    display="flex"
                    alignItems="center"
                  >
                    <Radio
                      value="PDF"
                      name="radio-button-sort"
                      className={clsx(classes.radioButton)}
                      py={1}
                    />
                    <Box>PDF</Box>
                  </Box>
                  <Box
                    component="p"
                    m={0}
                    pb={1}
                    color="#5A5B5E"
                    fontSize="12px"
                    display="flex"
                    alignItems="center"
                  >
                    <Radio
                      value="MSExcel"
                      name="radio-button-sort"
                      className={clsx(classes.radioButton)}
                      py={1}
                    />
                    <Box>MS Excel</Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box px={3} pt={3} pb={5}>


        <Box className={classes.root}>
            <TableContainer
              component={Paper}
              className={clsx(classes.TableTheme)}
            >
              <Table
                aria-label="collapsible table"
                className={classes.tableLayout}
              >
                <TableHead>
                  <TableRow>
                  <StyledTableCell className="bl-bg">
                  VPS ID	
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Cust ID
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                   Usage
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Type
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Description
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Make
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Model
                    </StyledTableCell>
                    {/* <StyledTableCell className="bl-bg">
                    Location
                    </StyledTableCell>*/}

                    <StyledTableCell className="bl-bg">
                    Lube Brand
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Lube Grade
                    </StyledTableCell>                     <StyledTableCell className="bl-bg">
                    System Oil
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Template
                    </StyledTableCell>
                    {/* <StyledTableCell className="bl-bg">
                    Info
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Test Limit
                    </StyledTableCell> */}
                    <StyledTableCell className="bl-bg">
                    Last Sampling Date 
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Frequency
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Next Sampling Date
                    </StyledTableCell>
                    {/* <StyledTableCell className="bl-bg">
                    Modified By
                    </StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  
          {dataOfEquipement.length
            ? dataOfEquipement.map((row) => (

                <TableRow>
                 
                    <StyledTableCell  >
                    <Box>{row.vpsId}</Box> 
                    </StyledTableCell>
                    <StyledTableCell  >
                    <Box>{row.custId}</Box> 
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box>{row.usage}</Box> 
                    </StyledTableCell>  
                    <StyledTableCell >
                    <Box>{row.type}</Box> 
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box>{row.description}</Box> 
                    </StyledTableCell>
                     <StyledTableCell >
                    <Box>{row.make}</Box>
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box> {row.model}</Box>
                    </StyledTableCell>
                   {/*  <StyledTableCell >
                   <Box>{row.Location}</Box> 
                    </StyledTableCell>*/}
                    <StyledTableCell >
                    <Box>{row.lubeBrand}</Box> 
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box>{row.lubeGrade}</Box> 
                    </StyledTableCell> 
                    <StyledTableCell >
                    <Box>{row.systemOilVolume}</Box>
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box> {row.template}</Box>
                    </StyledTableCell>
                    {/* <StyledTableCell >
                    <Box>{row.Info}</Box> 
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box>{row.TestLimit}</Box> 
                    </StyledTableCell> */}
                    <StyledTableCell >
                    <Box>{row.lastSamplingDate ?(<Moment format="DD/MM/YYYY">{row.lastSamplingDate}</Moment>):""}</Box> 
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box> {row.frequency}</Box>
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box> {row.nextSamplingDate ?(<Moment format="DD/MM/YYYY">{row.nextSamplingDate}</Moment>):""}</Box>
                    </StyledTableCell>
                    {/* <StyledTableCell >
                    <Box>{row.ModifiedBy }</Box>
                    </StyledTableCell> */}
                    
                    
                  </TableRow>
                )):(
                  <TableRow>
                    <TableCell>
                      No Data
                    </TableCell>
                  </TableRow>
                )}
                
                </TableBody>
              </Table>
            </TableContainer>
          </Box>


       
        {/*  <Box
            display="flex"
            py={2}
            px={2}
            className={clsx(
              commonClasses.justifyContentBetween,
              classes.text2,
              classes.rowHeaderBox,
              classes.rowBox
            )}
          >
           
          
           <Box>VPS Id</Box>
            <Box>Cust Id</Box>
            <Box>Usage</Box>
            <Box>Type</Box>
            <Box>Description</Box>
            <Box>Make</Box>
            <Box>Model</Box>
            <Box>Location</Box>
            <Box>Lube Brand</Box>
            <Box>Lube Grade</Box>
            <Box>System Oil </Box>
            <Box>Template </Box>
            <Box>Info </Box>
            <Box>Test Limit </Box>
            <Box>Last </Box>
            <Box>Frequence </Box>
            <Box>Next Sampling Date </Box>
           <Box borderRight="0px solid #000 !important">Modified By </Box>
         
         
  
         
         
         
           <Table >
           <thead>
             <tr>
               <th>VPS ID</th>
               <th>Cust ID</th>
               <th>Type</th>
               <th>Description</th>
               <th>Make</th>
               <th>Model</th>
               <th>Location</th>
               <th>Lube Brand</th>
               <th>Lube Grade</th>
               <th>System Oil</th>
               <th>Template</th>
               <th>Info</th>
               <th>Test Limit</th>
               <th>Last </th>
               <th>Frequence</th>
               <th>Next Sampling Date</th>
               <th>Modified By</th>

              
             </tr>
           </thead>
          

           </Table>
          </Box>*/}

          {/* <Box px={4} py={2} className={clsx(classes.text1, classes.rowBox)}>
            <Box display="flex" alignItems="center">
              <Box component="span" pr={2} color="#FF4717">
                <AddCircleOutlineIcon />
              </Box>
              <Box component="span" color="#FF4717">
                CLICK TO ADD NEW ITEM
              </Box>
            </Box>
          </Box> */}
           </Box>
           {/* <Paper className={classes.paper + " scrollBar"}
            style={{ height: "420px", overflow: "auto" }}>
<listStyled component="nav" className="scroll-list">
          {dataOfEquipement.length
            ? dataOfEquipement.map((row) => (

                <Box
                  display="flex"
                  py={2}
                  px={2}
                  className={clsx(
                    classes.text1,
                    commonClasses.justifyContentBetween,
                    classes.rowBox
                  )}
                 
                >
                  <Box>{row.vpsId}</Box>
                  <Box>{row.custId}</Box>
                  <Box>{row.usage}</Box>
                  <Box>{row.type}</Box>
                  <Box>{row.description}</Box>
                  <Box>{row.make}</Box>
                  <Box>{row.model}</Box>
                  <Box>{row.Location}</Box>
                  <Box>{row.lubeBrand}</Box>
                  <Box>{row.lubeGrade}</Box>
                  <Box>{row.systemOilVolume}</Box>
                  <Box>{row.template}</Box>
                  <Box>{row.Info}</Box>
                  <Box>{row.TestLimit}</Box>
                  <Box>{row.lastSamplingDate ?(<Moment format="DD/MM">{row.lastSamplingDate}</Moment>):""}</Box>
                  <Box>{row.frequency  ?(<Moment format="DD/MM">{row.frequency}</Moment>):""}</Box>
                  <Box>{row.NextSamplingDate ?(<Moment format="DD/MM">{row.NextSamplingDate}</Moment>):""}</Box>
                  <Box>{row.ModifiedBy }</Box>
                  
                </Box>
                
            
              ))
            : "No records found"}
            </listStyled>
            </Paper> */}
       
      </Box>
    </div>
  );
}

CustomerContractDetails.propTypes = {};

export default CustomerContractDetails;
